import { useEffect } from 'react';
import splitClient from '../utils/splitClient';

/**
 * Initializes the Split.io client once an identifier (organisationId) is
 * available. Idempotent - safe to call on every render with the same id.
 */
const useSplitInit = (identifier?: string | null) => {
  useEffect(() => {
    if (!identifier) {
      return;
    }
    splitClient.setId(identifier);
    splitClient.initialize().catch((err) => {
      console.error('Split.io initialization failed', err);
    });
  }, [identifier]);
};

export default useSplitInit;
